<template>
  <div>
    <empty-comments-modal
        ref="emptyCommentsModal"
        @accepted="handleUpdate"
    ></empty-comments-modal>

    <div class="title">
      <h3>Commentaires</h3>
    </div>

    <hr>

    <template v-if="editing">
      <notifications v-if="anyErrors" :error="errorsResponseData"
        :fields="fields"></notifications>
      <textarea class="form-control" id="informations"
        aria-invalid="false" rows="5" v-model="comments" name="comments" required></textarea>
      <div style="margin-top: 20px;">
        <button class="btn btn-sm" @click="submitButtonClicked">Enregistrer</button>
        <button class="btn btn-sm btn-danger" @click="cancelButtonClicked">Annuler</button>
      </div>
    </template>

    <template v-else>
      <div>
        <pre v-if="text" style="margin-bottom: 20px;">{{text}}</pre>
        <span v-else>Pas de commentaires.</span>
        <button class="btn btn-sm pull-right" @click="editing = true">Modifier</button>
      </div>
    </template>
  </div>
</template>

<script type="text/babel">
  import Notifications from 'components/Form/Notifications'
  import EmptyCommentsModal from 'components/Customer/InformationsContent/EmptyCommentsModal'

  export default {
    props: [ "text", "update" ],

    components: {
      Notifications,
      EmptyCommentsModal
    },

    data () {
      return {
        editing: false,
        comments: "",
        errorsResponseData: {
          errors: []
        },
        fields: [{
          label: "Commentaires",
          model: "comments"
        }]
      }
    },

    created () {
      this.resetCommentsValue()
    },

    watch: {
      text (value) {
        this.comments = value
      }
    },

    methods: {
      resetCommentsValue () {
        this.comments = this.text
      },

      handleUpdate () {
        this.errorsResponseData = {
          errors: []
        }

        this.update(this.trimmedComments)
          .then(() => {
            this.editing = false
          })
          .catch((error) => {
            this.errorsResponseData = error.response.data
          })
      },

      submitButtonClicked () {
        if (_.isEmpty(this.trimmedComments)) {
          this.$refs.emptyCommentsModal.displayModal()
        } else {
          this.handleUpdate()
        }
      },

      cancelButtonClicked () {
        this.editing = false
        this.resetCommentsValue()
      }
    },

    computed: {
      trimmedComments () {
        return _.trim(this.comments)
      },

      anyErrors () {
        const data = this.errorsResponseData

        return !_.isEmpty(data.errors)
      }
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Comments.vue